import { render, staticRenderFns } from "./MPopupDomainConnectCheckSuccess.vue?vue&type=template&id=64bf1364&"
import script from "./MPopupDomainConnectCheckSuccess.vue?vue&type=script&lang=ts&"
export * from "./MPopupDomainConnectCheckSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports